// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { MESSAGE_CHANNELS } from "@/types/messaging";
var SEND_COMMUNICATIONS = "SendCommunications";
var isRecord = function (value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
};
var parse = function (value) {
    if (typeof value !== "string") {
        return value;
    }
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return undefined;
    }
};
/** Windmill writes the channel in lowercase ("whatsapp"); older entries used the enum value. */
var asChannel = function (value) {
    return typeof value === "string"
        ? MESSAGE_CHANNELS.find(function (channel) { return channel === value.toUpperCase(); })
        : undefined;
};
var asText = function (value) {
    return typeof value === "string" && value ? value : undefined;
};
/** The message an electoral log entry records, if it records one. */
export var electoralLogDelivery = function (message) {
    var _a;
    var entry = parse(message);
    if (!isRecord(entry) || !isRecord(entry.statement)) {
        return undefined;
    }
    var _b = entry.statement, head = _b.head, body = _b.body;
    var fromHead = isRecord(head) ? asChannel(head.channel) : undefined;
    var details = isRecord(body) ? parse(body[SEND_COMMUNICATIONS]) : undefined;
    if (!isRecord(details)) {
        return fromHead ? { channel: fromHead } : undefined;
    }
    return {
        channel: fromHead !== null && fromHead !== void 0 ? fromHead : asChannel(details.channel),
        messageId: asText(details.message_id),
        outcome: (_a = asText(details.outcome)) !== null && _a !== void 0 ? _a : asText(details.state),
        attempt: typeof details.attempt === "number" ? details.attempt : undefined,
        reason: asText(details.reason),
    };
};
/** The messaging channel an electoral log entry records, if it records one. */
export var electoralLogChannel = function (message) { var _a; return (_a = electoralLogDelivery(message)) === null || _a === void 0 ? void 0 : _a.channel; };
